import type { ProjectFileStreamKind } from '../types';

/** Version-track kinds suppliers may see on the Project Hub Files tab (award-scoped). */
export const SUPPLIER_HUB_FILE_STREAM_KINDS: readonly ProjectFileStreamKind[] = [
  'three_d_raw',
  'two_d_pdf',
];

export function isSupplierHubVisibleStreamKind(
  kind: ProjectFileStreamKind | string | undefined,
): boolean {
  return kind === 'three_d_raw' || kind === 'two_d_pdf';
}
